const CheckIconBlack = () => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 35 35"
    width="35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17.5" cy="17.5" fill="#2A2929" r="17.5" />
    <path
      d="M11 17.3463L15.8832 22.9051C15.9094 22.935 15.9414 22.9589 15.9771 22.9752C16.0128 22.9916 16.0514 23 16.0904 23C16.1294 23 16.168 22.9916 16.2037 22.9752C16.2394 22.9589 16.2714 22.935 16.2976 22.9051L25 13"
      stroke="#F77115"
      strokeLinecap="round"
      strokeWidth="3"
    />
  </svg>
)

export default CheckIconBlack
